import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const TabsStyles = css(
    ({ theme: { spacing, palette, border } }) => css`
        .Tabs {
            .TabGroupContainer {
                column-gap: 0;
                padding: 0;
                border-bottom: ${border.sm};
                justify-content: space-between;
                padding: ${spacing.all(0, 3)};
            }
            .TabsTab {
                flex: 1;
                display: flex;
                justify-content: center;
                padding: ${spacing.all(4, 0, 2, 0)};
                color: ${palette.lightText};
                ${getTypographyStyle("body3Strong")};
                &.Active {
                    color: ${palette.primary};
                }
            }
            .TabIndicator {
                height: 1px;
            }
        }
    `,
);
